module.exports = __webpack_public_path__ + "img/payment_due.332b5cd0.svg";